import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconLinkBrokenSvg } from "./IconLinkBrokenSvg.mjs";
const IconLinkBroken = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconLinkBrokenSvg, ...svgProps }) });
export {
  IconLinkBroken
};
